import { tns } from "tiny-slider/src/tiny-slider"
import debounce from "lodash/debounce"

export default function init() {
  if (document.querySelector(".carousel")) {
    const main = tns({
      container: document.querySelector(".carousel-items"),
      items: 1,
      slideBy: "page",
      controls: false,
      nav: false,
    })

    const nav = tns({
      container: document.querySelector(".carousel-previews"),
      items: 2,
      slideBy: "page",
      controls: false,
      nav: false,
      fixedWidth: 405,
      touch: false,
      mouseDrag: false,
      responsive: {
        992: {
          items: 2,
          fixedWidth: 405,
        },
      },
    })

    const nextButton = document.querySelector(".carousel-navigation__next")
    const previousButton = document.querySelector(".carousel-navigation__previous")

    const onIndexChanged = function(info) {
      if (info.container.classList.contains("carousel-items")) {
        const currentSlide = document.querySelector(`#tns2-item${info.displayIndex - 1}`)
        const activeSlides = document.querySelectorAll(".carousel-preview--active")

        for (let i = 0; i < activeSlides.length; i++) {
          activeSlides[i].classList.remove("carousel-preview--active")
        }

        if (currentSlide) {
          currentSlide.classList.add("carousel-preview--active")
        } else {
          const firstSlide = document.querySelector("#tns2-item0")

          if (firstSlide) {
            firstSlide.classList.add("carousel-preview--active")
          }
        }

        nav.goTo(info.displayIndex - 1)

        if (window.matchMedia("(max-width: 992px)").matches) {
          if (info.displayIndex === 1) {
            const mobileFirstSlide = document.querySelector(`#tns1-item${info.displayIndex - 1}`)

            if (mobileFirstSlide) {
              mobileFirstSlide.style.paddingLeft = 0
            }

            if (previousButton && previousButton.classList.contains("carousel-navigation__previous--visible")) {
              previousButton.classList.remove("carousel-navigation__previous--visible")
            }

            if (info.indexCached === info.slideCount) {
              if (nextButton && nextButton.classList.contains("carousel-navigation__next--hidden")) {
                nextButton.classList.remove("carousel-navigation__next--hidden")
              }
            }
          } else if (info.displayIndex === info.slideCount) {
            if (nextButton) {
              nextButton.classList.add("carousel-navigation__next--hidden")
            }
            if (previousButton && info.slideCount > 1) {
              previousButton.classList.add("carousel-navigation__previous--visible")
            }
          } else {
            if (previousButton) {
              previousButton.classList.add("carousel-navigation__previous--visible")
            }

            if (nextButton && nextButton.classList.contains("carousel-navigation__next--hidden")) {
              nextButton.classList.remove("carousel-navigation__next--hidden")
            }
          }
        }
      }
    }

    main.events.on("transitionEnd", onIndexChanged)

    if (nextButton) {
      nextButton.addEventListener(
        "click",
        debounce(function() {
          main.goTo("next")
        }, 300)
      )
    }

    if (previousButton) {
      previousButton.addEventListener(
        "click",
        debounce(function() {
          main.goTo("prev")
        }, 300)
      )
    }

    const previews = document.querySelectorAll(".carousel-preview")
    const onPreviewClick = ev => {
      const index = ev.target.getAttribute("data-slide-index")

      main.goTo(index - 1)
    }

    previews.forEach(preview => {
      preview.addEventListener("click", onPreviewClick)
    })
  }
}
